/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import core from '../../app.core.module.js';
import establishMemwordConfig from './establishmemword.config.js';
import establishMemwordRoute from './establishmemword.route.js';
import establishMemwordController from './establishmemword.controller.js';
import establishMemwordService from './establishmemword.service.js';
import establishMemwordDataService from './establishmemword.data.service.js';

/**
 * This is the establishmemword module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace establishmemword Module
 */
angular.module('establishMemword', [
  // Shared modules.
  core
])
// Register config.
.config(establishMemwordConfig)
// Register route.
.config(establishMemwordRoute)
// Register controller.
.controller('establishMemwordController', establishMemwordController)
// Register service.
.factory('establishMemwordService', establishMemwordService)
// Register data service.
.factory('establishMemwordDataService', establishMemwordDataService);

export default 'establishMemword';


// WEBPACK FOOTER //
// ./src/login/establishmemword/establishmemword.module.js